import React from "react";

export default function QuickPlayPageContentLoader() {
	return (
		<div className="card--primary__body">
			<div className="offer--most__grid">
				{Array.from({ length: 8 }, (_, index) => (
					<div
						className="card--primary card--shared card--shared--borderless"
						key={index}
					>
						<div className="card--shared__header">
							<div className="card--shared__image loader--skeleton loader--skeleton__btn u-padd--med" />

							<div className="card--shared__inner loader--skeleton loader--skeleton__btn u-padd--med" />
						</div>

						<div className="card--primary__body u-padd--reset">
							<div className="row">
								<div className="col u-display--f u-display--f--col u-gap--xsml">
									<span className="loader--skeleton loader--skeleton__btn u-padd--xtny" />
									<span className=" loader--skeleton loader--skeleton__btn u-padd--xtny" />
								</div>
								<div className="col u-display--f u-display--f--col u-gap--xsml">
									<span className="loader--skeleton loader--skeleton__btn u-padd--xtny" />
									<span className="loader--skeleton loader--skeleton__btn u-padd--xtny" />
								</div>
							</div>
						</div>

						<div className="card--shared__footer loader--skeleton loader--skeleton__btn loader--skeleton__title--xsml u-padd--xtny" />
					</div>
				))}
			</div>
		</div>
	);
}
